

































































import Vue from 'vue';
import SettingsConnectStripe from '@/components/Settings/SettingsConnectStripe.vue';
import SettingsConnectBraintree from '@/components/Settings/SettingsConnectBraintree.vue';
import SettingsConnectChargebee from '@/components/Settings/SettingsConnectChargebee.vue';
import SettingsConnectPaddle from '@/components/Settings/SettingsConnectPaddle.vue';
import { IState } from '@/store/types';
import { mapGetters, mapState } from 'vuex';
import { SET_ORG_DETAILS } from '@/store/mutation-types';
import eventBus from '@/helpers/event-bus';
import { SYNC_ORG } from '@/store/action-types';

type ProviderOption = {
  name: string;
  label: string;
  img: string;
};

const providerOptions: ProviderOption[] = [
  {
    name: 'stripe',
    label: 'Stripe',
    img: 'stripe.svg',
  },
  {
    name: 'chargebee',
    label: 'Chargebee',
    img: 'chargebee.png',
  },
  {
    name: 'braintree',
    label: 'Braintree',
    img: 'braintree-icon.jpeg',
  },
  {
    name: 'paddle',
    label: 'Paddle',
    img: 'paddle-icon.jpeg',
  },
];

export default Vue.extend({
  name: 'SettingsBillingProvider',
  components: {
    SettingsConnectStripe,
    SettingsConnectChargebee,
    SettingsConnectBraintree,
    SettingsConnectPaddle,
  },
  async created() {
    await this.$store.dispatch(SYNC_ORG);
  },
  data() {
    return {
      providerOptions,
      // confirmedPaymentProvider: null,
    };
  },
  computed: {
    ...mapState(['org']),
    ...mapGetters(['confirmedPaymentProvider']),
    settingsToShow(): string | null {
      return this.confirmedPaymentProvider || this.selectedProvider || null;
    },
    selectedProvider(): string | undefined {
      const state = this.$store.state as IState;
      return this.confirmedPaymentProvider || state.org?.paymentProvider || 'stripe';
    },
    selectedProviderData(): ProviderOption | null {
      if (this.selectedProvider) {
        return this.providerOptions.find((d) => d.name === this.selectedProvider) || null;
      }
      return null;
    },
    lockedProvider(): boolean | undefined {
      return !!this.confirmedPaymentProvider;
    },
  },
  methods: {
    openChat() {
      eventBus.$emit('openChat');
    },
    async setPaymentProvider(paymentProvider: string) {
      const payload = { paymentProvider };
      try {
        // await OrgService.update(this.org._id, payload);
        this.$store.commit(SET_ORG_DETAILS, payload);
      } catch (error) {
        console.log('Error', error);
      }
    },
  },
});
